import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return null; // Or a loading spinner
  }

  if (isAuthenticated) {
    // Redirect to home if user is already logged in
    return <Navigate to="/profile" replace />;
  }

  return children;
};

export default PublicRoute;